<template>
  <v-app class="container">
    <!-- Side Bar -->
    <v-navigation-drawer
      app
      class="app-drawer"
      color="#1e2340"
      v-model="drawer"
      :width="screenSize === 'Large' ? 240 : ''"
    >
      <div class="logo-bc">
        <v-img class="mx-auto mb-2" height="56" max-width="110" :src="logoSrc"></v-img>
      </div>
      <v-divider class="drawer-divider" />

      <ul class="nav-list">
        <li class="nav-block" v-for="(item, index) in visibleNavLinks" :key="item.title">
          <div
            class="nav-row"
            :class="{ 'nav-row-active': item.title === selectedMenu }"
            @click="!show ? openSubMenus(item, index) : close(item)"
          >
            <v-icon
              class="ml-4 nav-icon"
              size="20"
              :color="item.title === selectedMenu ? '#ffffff' : '#9599b3'"
              :icon="item.icon"
            ></v-icon>
            <span class="ml-3 nav-title" :class="item.title === selectedMenu ? 'nav-title-active' : ''">
              {{ item.title }}
            </span>
            <v-spacer />
            <v-icon
              class="mr-4 chevron"
              size="16"
              color="#9599b3"
              v-if="item.children.length > 0"
            >
              {{ show && item.title === selectedMenu ? "mdi-chevron-up" : "mdi-chevron-down" }}
            </v-icon>
          </div>

          <ul v-if="show && item.title === selectedMenu" class="sub-nav-list">
            <li
              v-for="(child, i) in item.children"
              :key="i"
              class="sub-nav-row"
              :class="{ 'sub-nav-row-active': child.title === selectedChild }"
              @click="navigate(child.to, item.title, child.title)"
            >
              <span class="sub-dot"></span>
              <span>{{ child.title }}</span>
            </li>
          </ul>
        </li>
      </ul>
    </v-navigation-drawer>

    <v-app-bar app color="#ffffff" height="76" variant="flat" :elevation="0" class="app-topbar">
      <template v-slot:prepend>
        <v-icon
          class="ml-4"
          size="22"
          color="#50568e"
          icon="mdi-format-align-left"
          @click="drawer = !drawer"
        ></v-icon>
      </template>

      <v-row no-gutters align="center" class="pr-4">
        <v-spacer />

        <div class="datetime-chip mr-4">
          <v-icon size="16" color="#8a8a9a" class="mr-1">mdi-calendar-clock</v-icon>
          {{ getFormattedDateTime() }}
        </div>

        <div class="user-chip mr-2">
          <div class="user-name">{{ profile.email || "" }}</div>
          <div class="user-company">{{ profile.company_name || "" }}</div>
        </div>

        <v-menu>
          <template v-slot:activator="{ props }">
            <v-avatar class="mr-2 user-avatar" v-bind="props">
              <v-icon color="#50568e" size="x-large">mdi-account-circle</v-icon>
            </v-avatar>
          </template>
          <v-list rounded="lg" class="pa-1">
            <v-list-item>
              <v-list-item-title class="profile-text">
                {{ profile.is_admin ? "Admin" : "User" }}
              </v-list-item-title>
            </v-list-item>
            <v-divider class="my-1" />
            <v-list-item @click="logOut()">
              <v-list-item-title class="d-flex align-center">
                <v-icon color="#e2564b" size="small" class="mr-2">mdi-logout</v-icon>
                Log out
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-row>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import AuthService from "@/modules/auth/views/authService";

export default {
  name: "homePage",

  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("dashboard/getProDetails");
    });
  },

  data: () => ({
    rail: false,
    drawer: null,
    mini: false,
    selectedItem: 0,
    show: false,
    direction: "top",
    fab: false,
    fling: false,
    hover: false,
    tabs: null,
    left: true,
    top: false,
    right: true,
    bottom: true,
    openSubmenu: false,
    selectedMenu: "",
    selectedChild: "",
    transition: "slide-x-reverse-transition",
    screenSize: "",
    test: true,
  }),

  computed: {
    logoSrc() {
      const domain = window.location.hostname;
      if (domain.includes("fundraign")) {
        return "https://www.cfre.org/wp-content/uploads/2013/09/NEW-KAFP-LOGO-2014-1024x460.jpg";
      }
      return "../../../logo.png";
    },
    auth() {
      return AuthService;
    },
    profile() {
      return this.$store.getters["dashboard/dashboardGetters"]("profile");
    },
    isAdmin() {
      return this.profile.is_admin;
    },
    navLinks() {
      return [
        {
          to: "/dashboard/stats",
          icon: "mdi-chart-pie",
          title: "Dashboard",
          disabled: false,
          children: [],
          hidden: false,
        },
        {
          to: "",
          icon: "mdi-tooltip",
          title: "Subscribers",
          disabled: false,
          hidden: false,
          children: [
            { to: "/sub-list", title: "All Subscribers", icon: "", disabled: false, children: [] },
            // { to: "/subscriber", title: "Add Subscriber", icon: "", disabled: false, children: [] },
            { to: "/blacklisted-list", title: "Blacklist", icon: "", disabled: false, children: [] },
          ],
        },
        {
          to: "",
          icon: "mdi-format-align-justify",
          title: "Lists",
          disabled: false,
          hidden: false,
          children: [
            { to: "/all-lists", title: "All Lists", icon: "", disabled: false, children: [] },
            // { to: "/add-list", title: "Add List", icon: "", disabled: false, children: [] },
          ],
        },
        {
          to: "",
          icon: "mdi-alpha-b-box",
          title: "Templates",
          disabled: false,
          hidden: false,
          children: [
            { to: "/temp-list", title: "All Templates", icon: "", disabled: false, children: [] },
            { to: "/add-template", title: "Add Template", icon: "", disabled: false, children: [] },
          ],
        },
        {
          to: "",
          icon: "mdi-memory",
          title: "Campaigns",
          disabled: false,
          children: [
            { to: "/all-campaigns", title: "All Campaigns", icon: "", disabled: false, children: [] },
            // { to: "/add-campaign", title: "Add Campaign", icon: "", disabled: false, children: [] },
            { to: "/emails-by-campaign", title: "Emails per Campaign", icon: "", disabled: false, children: [] },
          ],
        },
        {
          to: "",
          icon: "mdi-email",
          title: "Emails",
          disabled: false,
          children: [
            { to: "/all-emails", title: "All Emails", icon: "", disabled: false, children: [] },
          ],
        },
        {
          to: "",
          icon: "mdi-account",
          title: "Users",
          disabled: false,
          hidden: !this.isAdmin,
          children: [
            { to: "/invite-user", title: "Invite User", icon: "", disabled: false, children: [] },
            { to: "/dashboard/all-users", title: "View Users", icon: "", disabled: false, children: [] },
            { to: "/dashboard/user-activity", title: "User Activity", icon: "", disabled: false, children: [] },
          ],
        },
      ];
    },

    visibleNavLinks() {
      return this.navLinks.filter((item) => !item.hidden);
    },
  },

  methods: {
    getFormattedDateTime() {
      const now = new Date();
      const options = {
        year: "numeric",
        month: "long",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      };
      return now.toLocaleString("en-US", options);
    },
    logout() {
      AuthService.logout();
    },
    redirect() {
      this.$router.push({ name: "mainDashboard" });
    },
    openSubMenus(item, val) {
      this.selectedChild = "";
      this.selectedMenu = item.title;
      const navChildren = this.navLinks[val].children;
      this.children = [...navChildren];
      this.show = true;
      if (item.to && item.children.length === 0) {
        this.navigate(item.to, item.title, "");
      }
    },
    close(val) {
      if (this.show && this.selectedMenu === val.title) {
        this.show = false;
      } else {
        this.selectedMenu = val.title;
        this.show = true;
      }
    },
    navigate(to, parentTitle, childTitle) {
      if (!to) return;
      this.$router.push({ path: to });
      this.selectedMenu = parentTitle;
      this.selectedChild = childTitle;
      localStorage.setItem("activeMenu", JSON.stringify({ parent: parentTitle, child: childTitle }));
    },
    logOut() {
      AuthService.logout();
    },
    setActiveMenuFromLocalStorage() {
      const activeMenu = JSON.parse(localStorage.getItem("activeMenu"));
      if (activeMenu) {
        this.selectedMenu = activeMenu.parent;
        this.selectedChild = activeMenu.child;
        if (activeMenu.child) {
          this.show = true;
        }
      }
    },
    findPath(val) {
      const subscriberObject = this.navLinks.find((obj) => obj.children.some((child) => child.to === val));
      if (subscriberObject) {
        const parentTitle = subscriberObject.title;
        const childTitle = subscriberObject.children.find((child) => child.to === val).title;
        this.selectedMenu = parentTitle;
        this.selectedChild = childTitle;
        this.show = true;
      }
    },
    checkScreenSize() {
      const isSmallScreen = window.matchMedia("(max-width: 600px)").matches;
      this.screenSize = isSmallScreen ? "Small" : "Large";
    },
  },

  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
    this.interval = setInterval(() => {
      this.currentTime = new Date();
    }, 1000);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
    if (this.interval) clearInterval(this.interval);
  },

  created() {
    this.setActiveMenuFromLocalStorage();
  },
};
</script>

<style>
@import url("../dashboardStyle.css");
</style>

<style scoped>
.app-drawer {
  border-right: none !important;
}

.logo-bc {
  padding: 24px 16px 12px;
}

.drawer-divider {
  border-color: rgba(255, 255, 255, 0.08) !important;
  margin-bottom: 8px;
}

.nav-list {
  list-style: none;
  padding: 8px 10px;
  margin: 0;
}

.nav-block {
  margin-bottom: 4px;
}

.nav-row {
  display: flex;
  align-items: center;
  height: 44px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.nav-row:hover {
  background: rgba(255, 255, 255, 0.06);
}

.nav-row-active {
  background: #50568e;
}

.nav-title {
  font-size: 13.5px;
  font-weight: 500;
  color: #b6bad1;
}

.nav-title-active {
  color: #fff;
  font-weight: 600;
}

.chevron {
  transition: transform 0.15s ease;
}

.sub-nav-list {
  list-style: none;
  padding: 4px 0 6px 44px;
  margin: 0;
}

.sub-nav-row {
  display: flex;
  align-items: center;
  height: 36px;
  font-size: 12.5px;
  color: #9599b3;
  cursor: pointer;
  border-radius: 8px;
  padding-left: 8px;
  transition: color 0.15s ease, background 0.15s ease;
}

.sub-nav-row:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.05);
}

.sub-nav-row-active {
  color: #fff;
  font-weight: 600;
}

.sub-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: currentColor;
  margin-right: 10px;
  flex-shrink: 0;
}

.app-topbar {
  border-bottom: 1px solid #eceef2;
}

.datetime-chip {
  display: flex;
  align-items: center;
  font-size: 12.5px;
  color: #8a8a9a;
  background: #f5f6fa;
  padding: 6px 12px;
  border-radius: 20px;
}

.user-chip {
  text-align: right;
  line-height: 1.2;
}

.user-name {
  font-size: 13px;
  font-weight: 600;
  color: #2d2a4a;
}

.user-company {
  font-size: 11px;
  color: #9a9aa8;
}

.user-avatar {
  cursor: pointer;
  transition: transform 0.15s ease;
}

.user-avatar:hover {
  transform: scale(1.05);
}

.profile-text {
  font-weight: 600;
  color: #2d2a4a;
}
</style>